'use client';

import Script from 'next/script';

import { getENV } from '../../../utils/env';

export const GtmLegacy = () => {
    const {
        NEXT_PUBLIC_LOCALE,
        NEXT_PUBLIC_GTM_CA_CONTAINER_ID,
        NEXT_PUBLIC_GTM_CA_PREVIEW,
        NEXT_PUBLIC_GTM_CA_AUTH,
        NEXT_PUBLIC_GTM_US_CONTAINER_ID,
        NEXT_PUBLIC_GTM_US_PREVIEW,
        NEXT_PUBLIC_GTM_US_AUTH,
    } = getENV();

    const isCA = NEXT_PUBLIC_LOCALE === 'en-CA';
    const { gtmAuth, gtmPreview, gtmContainerId } = isCA
        ? {
              gtmContainerId: NEXT_PUBLIC_GTM_CA_CONTAINER_ID,
              gtmPreview: NEXT_PUBLIC_GTM_CA_PREVIEW,
              gtmAuth: NEXT_PUBLIC_GTM_CA_AUTH,
          }
        : {
              gtmContainerId: NEXT_PUBLIC_GTM_US_CONTAINER_ID,
              gtmPreview: NEXT_PUBLIC_GTM_US_PREVIEW,
              gtmAuth: NEXT_PUBLIC_GTM_US_AUTH,
          };

    return (
        <Script
            id="gtm-script"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `
(function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),
    dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.onload = function() {
        console.log('GTM Loaded at', Date.now());
        w[l].push({event: 'loaded-gtm'})
    }
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x';
    f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmContainerId}');
`,
            }}
        />
    );
};
